import { Tabs } from "../../UI/Tabs/Tabs";
import WebhookList from "./WebhookList";
import WebhookLogList from "./WebhookLogList";

export default function Webhooks() {
  return (
    <>
      <Tabs id="oodrive-webhooks" defaultValue="webhooks">
        <Tabs.List>
          <Tabs.Tab value="webhooks">Webhooks</Tabs.Tab>
          <Tabs.Tab value="logs">Logs</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="webhooks">
          <WebhookList />
        </Tabs.Panel>
        <Tabs.Panel value="logs">
          <WebhookLogList />
        </Tabs.Panel>
      </Tabs>
    </>
  );
}
